import FarloUiCrm from './vendors/farlo-ui-crm';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import { merchandiseAdd } from './app/merchandiseAdd';

((document, window, history) => {
	if (document.querySelector('.merchandise-list')) {
		merchandiseAdd();
	}

	if (document.querySelector('#calendar')) {
		window.perfsAvailable = {
			id: 'availablePerfs',
			events: performanceData.instances.available,
			color: '#fff',
			textColor: '#fff'
		};

		window.perfsSoldout = {
			id: 'soldoutPerfs',
			events: performanceData.instances.sold_out,
			color: 'rgba(255,255,255,0.2)',
			textColor: '#fff'
		};

		let isMobile = false;
		const getStackSize = () => {
			if (window.innerWidth < 980) {
				isMobile = true;
			} else {
				isMobile = false;
			}
		};
		window.addEventListener('resize', () => {
			getStackSize();
		});
		getStackSize();

		document.addEventListener('DOMContentLoaded', function() {
			const calendarEl = document.getElementById('calendar');
			window.calendar = new FullCalendar.Calendar(calendarEl, {
				height: 'auto',
				headerToolbar: {
					start: 'prev',
					center: 'title',
					end: 'next'
				},
				firstDay: 1,
				showNonCurrentDates: true,
				validRange: {
					start: performanceData.instances.month_range[ 0 ],
					end: performanceData.instances.month_range[ 1 ]
				},
				visibleRange: {
					start: performanceData.instances.range[ 0 ],
					end: performanceData.instances.range[ 1 ]
				},
				fixedWeekCount: false,
				dayMaxEventRows: isMobile ? 0 : 2,
				dayMaxEvents: isMobile ? 0 : 2,
				eventMaxStack: isMobile ? 0 : 2,
				initialView: 'dayGridMonth',
				//initialView:'listWeek',
				//initialView: 'listMonth',
				eventSources: [perfsAvailable, perfsSoldout],
				eventTimeFormat: {
					hour: '2-digit',
					minute: '2-digit',
					hour12: false
				},
				windowResize(arg) {
					calendar.setOption('dayMaxEventRows', isMobile ? 0 : 2);
					calendar.setOption('dayMaxEvents', isMobile ? 0 : 2);
					calendar.setOption('eventMaxStack', isMobile ? 0 : 2);
				},
				dayCellContent(args) {
					const cellDate = new Date(args.date);
					let cellMonth = cellDate.getMonth() + 1;
					cellMonth = cellMonth < 10 ? '0' + cellMonth : cellMonth;
					let cellDay = cellDate.getDate();
					cellDay = cellDay < 10 ? '0' + cellDay : cellDay;
					const dateString =
						cellDate.getFullYear() +
						'-' +
						cellMonth +
						'-' +
						cellDay;

					let cellStr = `<span class='performance-cell-date'>
						<span class='performance-cell-day'>${ args.dayNumberText }</span>
					</span>`;

					const fromPrice =
						performanceData.instances.day_from_price[ dateString ];
					if (fromPrice) {
						cellStr = `<span class='performance-cell-date'>
							<span class='performance-cell-price'><span>From</span> ${ _farlo.helpers.strings.toCurrency(
		fromPrice
	) }</span>
							<span class='performance-cell-day'>${ args.dayNumberText }</span>
						</span>`;
					}
					return {
						html: cellStr
					};
				},
				moreLinkClick(info) {
					window.scrollTo(0, 0);
				},
				moreLinkContent(args) {
					if (isMobile) {
						return args.num + ' Times';
					}
					return args.text;
				},
				eventClassNames(args) {
					//console.log(args);
					if (
						parseInt(args.event.extendedProps.availability, 10) < 1
					) {
						return ['cal-availability-none'];
					}
					if (
						parseInt(args.event.extendedProps.availability, 10) <=
						performanceData.instances.availability_indicators.L
					) {
						return ['cal-availability-low'];
					}
					if (
						parseInt(args.event.extendedProps.availability, 10) <=
						performanceData.instances.availability_indicators.M
					) {
						return ['cal-availability-limited'];
					}
					return ['cal-availability-good'];
				}
				// eventContent: function(args) {
				// 	console.log(args);
				// 	if (parseInt(args.event.extendedProps.availability,10)  <= performanceData.instances.availability_indicators.M) {

				// 	}
				// 	return
				// }
			});
			calendar.render();

			setTimeout(() => {
				calendar.render();
			}, 100);
			//hideEmpty();
		});
	}

	const pushState = history.pushState;
	const youTubeRegex = RegExp(
		/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i
	);

	// default navicon
	function navicon() {
		document
			.querySelector('.site-navigation__navicon')
			.addEventListener('click', (e) => {
				e.preventDefault();
				e.currentTarget.classList.toggle(
					'site-navigation__navicon--active'
				);
				document
					.querySelector('.site-navigation')
					.classList.toggle('site-navigation--active');
				document.body.classList.toggle('site-navigation--open');
			});
	}

	// default navigation subnav
	function navigation(submenu) {
		if (
			'ontouchstart' in window ||
			navigator.maxTouchPoints > 0 ||
			navigator.msMaxTouchPoints > 0
		) {
			window._farlo.helpers
				.getSiblings(submenu)[ 0 ]
				.addEventListener('click', (e) => {
					if (
						!e.target.classList.contains(
							'site-navigation__menu-item--active'
						)
					) {
						e.preventDefault();

						e.currentTarget.classList.add(
							'site-navigation__menu-item--active'
						);
						submenu.classList.add(
							'site-navigation__sub-menu--active'
						);

						for (
							let i = 0;
							i <
							window._farlo.helpers.getSiblings(
								e.currentTarget.parentNode
							).length;
							i += 1
						) {
							if (
								window._farlo.helpers.getSiblings(
									e.currentTarget.parentNode
								)[ i ].children[ 0 ] &&
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[ i ].children[ 0 ].classList.contains(
										'site-navigation__menu-item--active'
									)
							) {
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[ i ].children[ 0 ].classList.remove(
										'site-navigation__menu-item--active'
									);
							}

							if (
								window._farlo.helpers.getSiblings(
									e.currentTarget.parentNode
								)[ i ].children[ 1 ] &&
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[ i ].children[ 1 ].classList.contains(
										'site-navigation__sub-menu--active'
									)
							) {
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[ i ].children[ 1 ].classList.remove(
										'site-navigation__sub-menu--active'
									);
							}
						}
					} else {
						return true;
					}
				});
		} else {
			submenu.parentNode.addEventListener('mouseover', () => {
				if (
					submenu.parentNode.querySelector(
						'.site-navigation__sub-menu--active'
					)
				) {
					submenu.parentNode
						.querySelectorAll('.site-navigation__sub-menu--active')
						.forEach((_sel) => {
							_sel.classList.remove(
								'site-navigation__sub-menu--active'
							);
							_sel.parentNode.classList.remove(
								'site-navigation__menu-item--active'
							);
						});
				}
				submenu.classList.add('site-navigation__sub-menu--active');
				submenu.parentNode.classList.add(
					'site-navigation__menu-item--active'
				);
			});

			submenu.parentNode.addEventListener('mouseout', () => {
				submenu.classList.remove('site-navigation__sub-menu--active');
				submenu.parentNode.classList.remove(
					'site-navigation__menu-item--active'
				);
			});
		}
	}

	function farloUiCrmSignup(_sel) {
		let farloUiSignupForm = null;

		if (typeof _sel.target !== 'undefined' && _sel.target !== null) {
			if (_sel.target.dataset.crmButtonFor !== '') {
				farloUiSignupForm = new FarloUiCrm(
					_sel.target.dataset.crmButtonFor
				);
			}
		} else if (farloUiSignupForm) {
			farloUiSignupForm.toggleForm();
		} else {
			farloUiSignupForm = new FarloUiCrm(_sel.id);
		}
	}

	function faqs() {
		const accordions = document.querySelectorAll(
			'.site-faqs__accordion-faq'
		);

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector(
				'.site-faqs__accordion-answer'
			);
			accordion.classList.add('site-faqs__accordion-faq--active');
			answer.parentElement.parentElement.style.height =
				parseInt(
					answer.parentElement.parentElement.dataset.height,
					10
				) +
				answer.scrollHeight +
				24 +
				'px';
			answer.style.height = answer.scrollHeight + 24 + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector(
				'.site-faqs__accordion-answer'
			);
			accordion.classList.remove('site-faqs__accordion-faq--active');
			answer.style.height = 0;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector(
				'.site-faqs__accordion-question'
			);
			const answer = accordion.querySelector(
				'.site-faqs__accordion-answer'
			);

			question.addEventListener('click', () => {
				if (answer.style.height && answer.style.height !== '0px') {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			});
		});
	}

	function farloUiLightbox(elem, div) {
		if (
			(elem.nextElementSibling && elem.nextElementSibling.value) ||
			(elem.querySelector('.site-farlo-ui-lightbox__html') &&
				elem.querySelector('.site-farlo-ui-lightbox__html').value) ||
			(elem.nextElementSibling &&
				elem.nextElementSibling.dataset.hasOwnProperty('lightbox'))
		) {
			elem.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				openLightbox(e, elem, div);
			});
		}

		if (elem.querySelector('a[href*="youtu.be"]')) {
			elem.querySelector('a[href*="youtu.be"]').addEventListener(
				'click',
				function(e) {
					e.preventDefault();
					openYouTubeLightbox(e, div);
				}
			);
		}

		if (div.querySelector('.site-farlo-ui-lightbox__button-close')) {
			div.querySelector(
				'.site-farlo-ui-lightbox__button-close'
			).addEventListener('click', function(e) {
				e.preventDefault();
				closeLightbox(div);
			});
		}

		// Close lightbox when clicking outside the inner content
		div.addEventListener('click', function(e) {
			if (!e.target.closest('.site-farlo-ui-lightbox__inner-content')) {
				closeLightbox(div);
			}
		});

		// Add keyboard accessibility
		document.addEventListener('keydown', function(e) {
			if (div.classList.contains('site-farlo-ui-lightbox--active')) {
				if (e.key === 'Escape') {
					closeLightbox(div);
				} else if (e.key === 'Tab') {
					// Trap focus within the lightbox
					trapFocus(div, e);
				}
			}
		});
	}

	function openLightbox(e, elem, div) {
		document.body.classList.add('body--farlo-ui-lightbox-open');
		div.querySelector(
			'.site-farlo-ui-lightbox__inner-content'
		).classList.add('dynamic');

		if (
			e.currentTarget.nextElementSibling &&
			e.currentTarget.nextElementSibling.value
		) {
			div.querySelector(
				'.site-farlo-ui-lightbox__inner-content'
			).innerHTML = e.currentTarget.nextElementSibling.value;
		} else if (
			e.currentTarget.querySelector('.site-farlo-ui-lightbox__html') &&
			e.currentTarget.querySelector('.site-farlo-ui-lightbox__html').value
		) {
			div.querySelector(
				'.site-farlo-ui-lightbox__inner-content'
			).innerHTML = e.currentTarget.querySelector(
				'.site-farlo-ui-lightbox__html'
			).value;
		} else if (
			e.currentTarget.nextElementSibling &&
			e.currentTarget.nextElementSibling.dataset.hasOwnProperty(
				'lightbox'
			)
		) {
			div.querySelector(
				'.site-farlo-ui-lightbox__inner-content'
			).innerHTML = e.currentTarget.nextElementSibling.innerHTML;
		}
		div.classList.add('site-farlo-ui-lightbox--active');
	}

	function openYouTubeLightbox(e, div) {
		document.body.classList.add('body--farlo-ui-lightbox-open');
		div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML =
			'<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' +
			e.target.href.match(youTubeRegex)[ 1 ] +
			'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
		div.classList.add('site-farlo-ui-lightbox--active');
	}

	function closeLightbox(div) {
		document.body.classList.remove('body--farlo-ui-lightbox-open');
		div.classList.remove('site-farlo-ui-lightbox--active');
		if (
			div.querySelector('.site-farlo-ui-lightbox__inner-content.dynamic')
		) {
			div.querySelector(
				'.site-farlo-ui-lightbox__inner-content'
			).classList.remove('dynamic');
		}
		div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML =
			'';
	}

	function trapFocus(div, e) {
		const focusableElements = div.querySelectorAll(
			'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
		);
		const firstElement = focusableElements[ 0 ];
		const lastElement = focusableElements[ focusableElements.length - 1 ];
		const ownerDocument = div.ownerDocument;

		if (e.shiftKey) {
			if (ownerDocument.activeElement === firstElement) {
				lastElement.focus();
				e.preventDefault();
			}
		} else if (ownerDocument.activeElement === lastElement) {
			firstElement.focus();
			e.preventDefault();
		}
	}
	function smoothScroll(_sel) {
		_sel.addEventListener('click', function(e) {
			e.preventDefault();

			if (
				document.querySelector('.site-navigation__navicon--active') &&
				document.body.classList.contains('site-navigation--open')
			) {
				document.querySelector('.site-navigation__navicon').click();
			}

			if (e.target.parentNode.parentNode) {
				e.target.parentNode.parentNode.classList.remove(
					'site-navigation__sub-menu--active'
				);
			}

			if (e.target.parentNode.parentNode.parentNode) {
				e.target.parentNode.parentNode.parentNode
					.querySelector('a')
					.classList.remove('site-navigation__menu-item--active');
			}

			if (
				e.target.href.includes('#') &&
				document.getElementById(e.target.href.split('#')[ 1 ])
			) {
				document
					.getElementById(e.target.href.split('#')[ 1 ])
					.scrollIntoView({ behavior: 'smooth' });
			} else {
				window.location.href = e.target.href;
			}
		});
	}

	function masterClassesWorkshopsCards() {
		const accordions = document.querySelectorAll(
			'.site-masterclass-workshops-cards__card'
		);

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector(
				'.site-masterclass-workshops-cards__card-info'
			);
			accordion.classList.add(
				'site-masterclass-workshops-cards__card--active'
			);
			answer.parentElement.parentElement.style.height =
				parseInt(
					answer.parentElement.parentElement.dataset.height,
					10
				) +
				answer.scrollHeight +
				24 +
				'px';
			answer.style.height = answer.scrollHeight + 24 + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector(
				'.site-masterclass-workshops-cards__card-info'
			);
			accordion.classList.remove(
				'site-masterclass-workshops-cards__card--active'
			);
			answer.style.height = 0;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector(
				'.site-masterclass-workshops-cards__card-image'
			);
			const answer = accordion.querySelector(
				'.site-masterclass-workshops-cards__card-info'
			);

			question.addEventListener('click', () => {
				if (answer.style.height && answer.style.height !== '0px') {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			});
		});
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		const lightboxEmbed = document.querySelectorAll(
			'.site-video-embed-group, .site-farlo-ui-lightbox__toggle, .wp-block-gallery'
		);
		let div;
		let divInner;
		let divInnerContent;
		let divClose;

		document.body.classList.add('loaded');

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document
				.querySelectorAll('.site-navigation__sub-menu')
				.forEach((_sel) => {
					navigation(_sel);
				});
		}

		if (lightboxEmbed.length > 0) {
			div = document.createElement('div');
			divInner = document.createElement('div');
			divInnerContent = document.createElement('div');
			divClose = document.createElement('button');
			div.className = 'site-farlo-ui-lightbox';
			divInner.className = 'site-farlo-ui-lightbox__inner';
			divInnerContent.className = 'site-farlo-ui-lightbox__inner-content';
			divClose.className = 'site-farlo-ui-lightbox__button-close';

			document.body.appendChild(div);
			document
				.querySelector('.site-farlo-ui-lightbox')
				.appendChild(divInner);
			document
				.querySelector('.site-farlo-ui-lightbox__inner')
				.appendChild(divInnerContent);
			document
				.querySelector('.site-farlo-ui-lightbox__inner')
				.appendChild(divClose);

			lightboxEmbed.forEach(function(elem) {
				farloUiLightbox(elem, div);
			});

			document
				.querySelectorAll('.site-farlo-ui-lightbox__trigger')
				.forEach((_sel) => {
					_sel.addEventListener('click', (e) => {
						e.stopImmediatePropagation();
						if (e.currentTarget.closest('.project-item')) {
							e.currentTarget
								.closest('.project-item')
								.querySelector(
									'.site-farlo-ui-lightbox__toggle'
								)
								.click();
						}
					});
				});
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.site-farlo-ui-crm')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm__toggle')) {
			document
				.querySelectorAll('.site-farlo-ui-crm__toggle')
				.forEach((_sel) => {
					_sel.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopImmediatePropagation();
						farloUiCrmSignup(e);
					});
				});
		}

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document
				.querySelectorAll('[farlo-ui="calendar"]')
				.forEach((_sel) => {
					_sel.farloUiTicketCalendar(_sel);
				});
		}
	});

	window.addEventListener('load', () => {
		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document
				.querySelectorAll('[farlo-ui="carousel"]')
				.forEach((_sel) => {
					_sel.farloUiRevolverCarousel();
				});
		}

		if (document.querySelector('.site-farlo-ui-lightbox')) {
			document
				.querySelectorAll('[farlo-ui="lightbox"]')
				.forEach((_sel) => {
					_sel.farloUiLightbox();
				});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker
			.getRegistrations()
			.then(function(registrations) {
				for (const registration of registrations) {
					registration.unregister();
				}
			});
	}

	const checkInputValue = (_inp, _ctrl) => {
		if (_inp.value) {
			_ctrl.classList.add('form-item-active');
		} else {
			_ctrl.classList.remove('form-item-active');
		}
	};

	function checkInputFields() {
		document.querySelectorAll('.form-field').forEach((_inp) => {
			_inp.addEventListener('focus', () => {
				_inp.parentElement.classList.add('form-item-active');
			});
			_inp.addEventListener('blur', () => {
				checkInputValue(_inp, _inp.parentElement);
			});
			checkInputValue(_inp, _inp.parentElement);
		});

		document.querySelectorAll('.farlo-ui-crm-input').forEach((_inp) => {
			const parentDiv = _inp.closest('.farlo-ui-crm-form-item');

			_inp.addEventListener('focus', () => {
				parentDiv.classList.add('form-item-active');
			});
			_inp.addEventListener('blur', () => {
				checkInputValue(_inp, parentDiv);
			});
			checkInputValue(_inp, parentDiv);
		});

		document
			.querySelectorAll(
				'.gfield input:not(.datepicker),.gfield textarea,.gfield select'
			)
			.forEach((_inp) => {
				const parentDiv = _inp.closest('.gfield');

				_inp.addEventListener('focus', () => {
					parentDiv.classList.add('form-item-active');
				});

				_inp.addEventListener('blur', () => {
					parentDiv.classList.remove('form-item-active');
					checkInputValue(_inp, parentDiv);
				});

				checkInputValue(_inp, parentDiv);
			});
	}
	checkInputFields();
	if (document.querySelector('.gform') && typeof jQuery !== 'undefined') {
		jQuery(document).on(
			'gform_post_render',
			function(event, form_id, current_page) {
				jQuery('div.gform_validation_errors').appendTo(
					'div.gform_body'
				);
				checkInputFields();
			}
		);
	}

	const checkScroll = () => {
		const scrollOffset = document.body.classList.contains('home')
			? document.querySelector('#intro-end').offsetTop
			: 0;

		if (window.scrollY > scrollOffset) {
			document.body.classList.add('scrolled');
		} else {
			document.body.classList.remove('scrolled');
		}
	};
	_farloUi.handlers.scroll.push(checkScroll);
	checkScroll();

	let resizeTimer;
	window.addEventListener('resize', () => {
		document.body.classList.add('resize-animation-stopper');
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			document.body.classList.remove('resize-animation-stopper');
		}, 400);
	});

	function authenticate(data, sel) {
		sel.classList.remove('site-account__login-register--loading');
		if (data.success) {
			document.querySelector('.site-account-actions').style.display =
				'flex';
			document.querySelector('.site-account-button').style.display =
				'none';
		} else {
			sel.querySelector('.form-message').innerHTML =
				'<ul><li>' + data.message.join('</li><li>') + '</li></ul>';
		}
	}
	function register(data, sel) {
		sel.classList.remove('site-account__login-register--loading');
		if (data.success) {
			sel.querySelector('form').style.display = 'none';
			sel.querySelector('h6').innerHTML = 'Thank you for registering.';
		} else {
			sel.querySelector('.form-message').innerHTML =
				'<ul><li>' + data.message.join('</li><li>') + '</li></ul>';
		}
	}
	if (document.querySelector('#farlo-register-form')) {
		document
			.querySelector('#farlo-register-form')
			.addEventListener('click', () => {
				document.querySelector('.site-account__login').style.display =
					'none';
				document.querySelector(
					'.site-account__register'
				).style.display = 'block';
			});
	}
	if (document.querySelector('#farlo-register-form')) {
		document
			.querySelector('#farlo-login-form')
			.addEventListener('click', () => {
				document.querySelector('.site-account__login').style.display =
					'block';
				document.querySelector(
					'.site-account__register'
				).style.display = 'none';
			});
	}

	if (document.querySelector('.site-mailing-list-banner')) {
		document.querySelector('.site-mailing-list-banner').querySelector('.site-mailing-list-banner__button').addEventListener('click', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			const tenDaysInSeconds = 10 * 24 * 60 * 60;
			window._farlo.storage.cookie.handle('mailing_list_banner', 'closed', tenDaysInSeconds);

			document.querySelector('.site-mailing-list-banner').style.display = 'none';
		});
	}

	if (document.querySelector('#farlo-login')) {
		document.querySelector('#farlo-login').addEventListener('click', () => {
			const sel = document.querySelector('.site-account__login');
			sel.classList.add('site-account__login-register--loading');

			const data = new FormData();
			data.append('action', 'farlo-login');
			data.append('nonce', farloAjaxHandler.nonce);
			data.append(
				'email',
				document.querySelector('#site-account__login-email').value
			);
			data.append(
				'password',
				document.querySelector('#site-account__login-password').value
			);

			fetch(farloAjaxHandler.ajaxurl, {
				method: 'POST',
				credentials: 'same-origin',
				body: data
			})
				.then((response) => response.json())
				.then((res) => {
					authenticate(res, sel);
				})
				.catch((error) => {
					console.error('Error:', error);
					sel.classList.remove(
						'site-account__login-register--loading'
					);
				});
		});
	}
	if (document.querySelector('#farlo-register')) {
		document
			.querySelector('#farlo-register')
			.addEventListener('click', () => {
				const sel = document.querySelector('.site-account__register');
				sel.classList.add('site-account__login-register--loading');

				const data = new FormData();
				data.append('action', 'farlo-subscribe');
				data.append('nonce', farloAjaxHandler.nonce);
				data.append(
					'email',
					document.querySelector('#site-account__register-email')
						.value
				);
				data.append(
					'firstName',
					document.querySelector('#site-account__register-first-name')
						.value
				);
				data.append(
					'lastName',
					document.querySelector('#site-account__register-last-name')
						.value
				);

				fetch(farloAjaxHandler.ajaxurl, {
					method: 'POST',
					credentials: 'same-origin',
					body: data
				})
					.then((response) => response.json())
					.then((data) => {
						register(data, sel);
						console.log(data);
					})
					.catch((error) => {
						console.error('Error:', error);
						sel.classList.remove(
							'site-account__login-register--loading'
						);
					});
			});
	}

	if (document.querySelector('.site-mailing-list-form')) {
		const form = document.getElementById('site-mailing-list-form__signup-form');
		const messageDiv = document.getElementById('signup-message');

		form.addEventListener('submit', async function(event) {
			event.preventDefault();

			const formData = new FormData();

			messageDiv.innerHTML = '';

			formData.append('action', 'farlo-customer-signup');
			formData.append('nonce', farloAjaxHandler.nonce);
			formData.append('first_name', document.getElementById('FirstName').value);
			formData.append('last_name', document.getElementById('LastName').value);
			formData.append('email', document.getElementById('Email').value);
			formData.append('marketing_opt_in', document.getElementById('MarketingOptIn').checked ? '1' : '0');
			formData.append('terms_accepted', document.getElementById('TermsAccepted').checked ? '1' : '0');

			try {
				const response = await fetch(farloAjaxHandler.ajaxurl, {
					method: 'POST',
					body: formData
				});

				const data = await response.json();

				if (response.ok && data.success) {
					messageDiv.textContent = 'Signup successful!';
					messageDiv.style.color = 'var(--global-primary-colour)';
					form.reset();
				} else {
					messageDiv.style.color = 'red';

					if (Array.isArray(data?.data?.message)) {
						data.data.message.forEach((errorMsg) => {
							const errorElement = document.createElement('p');
							errorElement.textContent = errorMsg;
							messageDiv.appendChild(errorElement);
						});
					} else {
						messageDiv.textContent = 'Error: ' + (data?.message || 'An unexpected error occurred.');
					}
				}
			} catch (error) {
				console.error('AJAX Fetch Error:', error);
				messageDiv.textContent = 'Error: ' + error.message;
				messageDiv.style.color = 'red';
			}
		});
	}

	if (document.querySelector('select')) {
		document.querySelectorAll('select').forEach((_sel) => {
			new FarloUiSelectBox(_sel);
		});
	}

	if (document.querySelector('.site-project__faqs-category-body')) {
		document
			.querySelectorAll('.site-project__faqs-category-header')
			.forEach((_faqCat) => {
				_faqCat.nextElementSibling.dataset.height =
					_faqCat.nextElementSibling.scrollHeight;
				_faqCat.addEventListener('click', () => {
					document
						.querySelectorAll('.site-project__faqs-category-header')
						.forEach((_faqHeader) => {
							_faqHeader.nextElementSibling.style.height = '0px';
						});
					_faqCat.nextElementSibling.style.height =
						_faqCat.nextElementSibling.dataset.height + 'px';
				});
			});
	}

	if (document.querySelector('.site-masterclass-workshops-cards')) {
		masterClassesWorkshopsCards();
	}

	if (document.querySelector('#booking-terms')) {
		document
			.querySelector('#booking-terms > h3')
			.addEventListener('click', () => {
				const list = document.querySelector('#booking-terms-info');
				list.style.height =
					list.style.height && list.style.height !== '0px'
						? '0px'
						: list.scrollHeight + 'px';
			});
	}

	if (
		document.body.classList.contains('postid-1090') ||
		document.body.classList.contains('page-id-1937')
	) {
		/**
		 * @license
		 * DHTML Snowstorm! JavaScript-based snow for web pages
		 * Making it snow on the internets since 2003. You're welcome.
		 * - ----------------------------------------------------------
		 * Version 1.44.20131208 (Previous rev: 1.44.20131125)
		 * Copyright (c) 2007, Scott Schiller. All rights reserved.
		 * Code provided under the BSD License
		 * http://schillmania.com/projects/snowstorm/license.txt
		 */

		/*jslint nomen: true, plusplus: true, sloppy: true, vars: true, white: true */
		/*global window, document, navigator, clearInterval, setInterval */

		const snowStorm = (function(window, document) {
			// --- common properties ---

			this.autoStart = true; // Whether the snow should start automatically or not.
			this.flakesMax = 128; // Limit total amount of snow made (falling + sticking)
			this.flakesMaxActive = 64; // Limit amount of snow falling at once (less = lower CPU use)
			this.animationInterval = 50; // Theoretical "miliseconds per frame" measurement. 20 = fast + smooth, but high CPU use. 50 = more conservative, but slower
			this.useGPU = true; // Enable transform-based hardware acceleration, reduce CPU load.
			this.className = null; // CSS class name for further customization on snow elements
			this.excludeMobile = false; // Snow is likely to be bad news for mobile phones' CPUs (and batteries.) By default, be nice.
			this.flakeBottom = null; // Integer for Y axis snow limit, 0 or null for "full-screen" snow effect
			this.followMouse = false; // Snow movement can respond to the user's mouse
			this.snowColor = '#fff'; // Don't eat (or use?) yellow snow.
			this.snowCharacter = '&bull;'; // &bull; = bullet, &middot; is square on some systems etc.
			this.snowStick = true; // Whether or not snow should "stick" at the bottom. When off, will never collect.
			this.targetElement = null; // element which snow will be appended to (null = document.body) - can be an element ID eg. 'myDiv', or a DOM node reference
			this.useMeltEffect = true; // When recycling fallen snow (or rarely, when falling), have it "melt" and fade out if browser supports it
			this.useTwinkleEffect = false; // Allow snow to randomly "flicker" in and out of view while falling
			this.usePositionFixed = false; // true = snow does not shift vertically when scrolling. May increase CPU load, disabled by default - if enabled, used only where supported
			this.usePixelPosition = false; // Whether to use pixel values for snow top/left vs. percentages. Auto-enabled if body is position:relative or targetElement is specified.

			// --- less-used bits ---

			this.freezeOnBlur = true; // Only snow when the window is in focus (foreground.) Saves CPU.
			this.flakeLeftOffset = 0; // Left margin/gutter space on edge of container (eg. browser window.) Bump up these values if seeing horizontal scrollbars.
			this.flakeRightOffset = 0; // Right margin/gutter space on edge of container
			this.flakeWidth = 8; // Max pixel width reserved for snow element
			this.flakeHeight = 8; // Max pixel height reserved for snow element
			this.vMaxX = 5; // Maximum X velocity range for snow
			this.vMaxY = 4; // Maximum Y velocity range for snow
			this.zIndex = 0; // CSS stacking order applied to each snowflake

			// --- "No user-serviceable parts inside" past this point, yadda yadda ---

			let storm = this,
				features,
				// UA sniffing and backCompat rendering mode checks for fixed position, etc.
				isIE = navigator.userAgent.match(/msie/i),
				isIE6 = navigator.userAgent.match(/msie 6/i),
				isMobile = navigator.userAgent.match(/mobile|opera m(ob|in)/i),
				isBackCompatIE = isIE && document.compatMode === 'BackCompat',
				noFixed = isBackCompatIE || isIE6,
				screenX = null,
				screenX2 = null,
				screenY = null,
				scrollY = null,
				docHeight = null,
				vRndX = null,
				vRndY = null,
				windOffset = 1,
				windMultiplier = 2,
				flakeTypes = 6,
				fixedForEverything = false,
				targetElementIsRelative = false,
				opacitySupported = (function() {
					try {
						document.createElement('div').style.opacity = '0.5';
					} catch (e) {
						return false;
					}
					return true;
				}()),
				didInit = false,
				docFrag = document.createDocumentFragment();

			features = (function() {
				let getAnimationFrame;

				/**
				 * hat tip: paul irish
				 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
				 * https://gist.github.com/838785
				 */

				function timeoutShim(callback) {
					window.setTimeout(
						callback,
						1000 / (storm.animationInterval || 20)
					);
				}

				const _animationFrame =
					window.requestAnimationFrame ||
					window.webkitRequestAnimationFrame ||
					window.mozRequestAnimationFrame ||
					window.oRequestAnimationFrame ||
					window.msRequestAnimationFrame ||
					timeoutShim;

				// apply to window, avoid "illegal invocation" errors in Chrome
				getAnimationFrame = _animationFrame
					? function() {
						return _animationFrame.apply(window, arguments);
					  }
					: null;

				let testDiv;

				testDiv = document.createElement('div');

				function has(prop) {
					// test for feature support
					const result = testDiv.style[ prop ];
					return result !== undefined ? prop : null;
				}

				// note local scope.
				const localFeatures = {
					transform: {
						ie: has('-ms-transform'),
						moz: has('MozTransform'),
						opera: has('OTransform'),
						webkit: has('webkitTransform'),
						w3: has('transform'),
						prop: null // the normalized property value
					},

					getAnimationFrame
				};

				localFeatures.transform.prop =
					localFeatures.transform.w3 ||
					localFeatures.transform.moz ||
					localFeatures.transform.webkit ||
					localFeatures.transform.ie ||
					localFeatures.transform.opera;

				testDiv = null;

				return localFeatures;
			}());

			this.timer = null;
			this.flakes = [];
			this.disabled = false;
			this.active = false;
			this.meltFrameCount = 20;
			this.meltFrames = [];

			this.setXY = function(o, x, y) {
				if (!o) {
					return false;
				}

				if (storm.usePixelPosition || targetElementIsRelative) {
					o.style.left = x - storm.flakeWidth + 'px';
					o.style.top = y - storm.flakeHeight + 'px';
				} else if (noFixed) {
					o.style.right = 100 - (x / screenX) * 100 + '%';
					// avoid creating vertical scrollbars
					o.style.top =
						Math.min(y, docHeight - storm.flakeHeight) + 'px';
				} else if (!storm.flakeBottom) {
					// if not using a fixed bottom coordinate...
					o.style.right = 100 - (x / screenX) * 100 + '%';
					o.style.bottom = 100 - (y / screenY) * 100 + '%';
				} else {
					// absolute top.
					o.style.right = 100 - (x / screenX) * 100 + '%';
					o.style.top =
						Math.min(y, docHeight - storm.flakeHeight) + 'px';
				}
			};

			this.events = (function() {
				const old = !window.addEventListener && window.attachEvent,
					slice = Array.prototype.slice,
					evt = {
						add: old ? 'attachEvent' : 'addEventListener',
						remove: old ? 'detachEvent' : 'removeEventListener'
					};

				function getArgs(oArgs) {
					const args = slice.call(oArgs),
						len = args.length;
					if (old) {
						args[ 1 ] = 'on' + args[ 1 ]; // prefix
						if (len > 3) {
							args.pop(); // no capture
						}
					} else if (len === 3) {
						args.push(false);
					}
					return args;
				}

				function apply(args, sType) {
					const element = args.shift(),
						method = [evt[ sType ]];
					if (old) {
						element[ method ](args[ 0 ], args[ 1 ]);
					} else {
						element[ method ].apply(element, args);
					}
				}

				function addEvent() {
					apply(getArgs(arguments), 'add');
				}

				function removeEvent() {
					apply(getArgs(arguments), 'remove');
				}

				return {
					add: addEvent,
					remove: removeEvent
				};
			}());

			function rnd(n, min) {
				if (isNaN(min)) {
					min = 0;
				}
				return Math.random() * n + min;
			}

			function plusMinus(n) {
				return parseInt(rnd(2), 10) === 1 ? n * -1 : n;
			}

			this.randomizeWind = function() {
				let i;
				vRndX = plusMinus(rnd(storm.vMaxX, 0.2));
				vRndY = rnd(storm.vMaxY, 0.2);
				if (this.flakes) {
					for (i = 0; i < this.flakes.length; i ++) {
						if (this.flakes[ i ].active) {
							this.flakes[ i ].setVelocities();
						}
					}
				}
			};

			this.scrollHandler = function() {
				let i;
				// "attach" snowflakes to bottom of window if no absolute bottom value was given
				scrollY = storm.flakeBottom
					? 0
					: parseInt(
						window.scrollY ||
								document.documentElement.scrollTop ||
								(noFixed ? document.body.scrollTop : 0),
						10
					  );
				if (isNaN(scrollY)) {
					scrollY = 0; // Netscape 6 scroll fix
				}
				if (!fixedForEverything && !storm.flakeBottom && storm.flakes) {
					for (i = 0; i < storm.flakes.length; i ++) {
						if (storm.flakes[ i ].active === 0) {
							storm.flakes[ i ].stick();
						}
					}
				}
			};

			this.resizeHandler = function() {
				if (window.innerWidth || window.innerHeight) {
					screenX = window.innerWidth - 16 - storm.flakeRightOffset;
					screenY = storm.flakeBottom || window.innerHeight;
				} else {
					screenX =
						(document.documentElement.clientWidth ||
							document.body.clientWidth ||
							document.body.scrollWidth) -
						(!isIE ? 8 : 0) -
						storm.flakeRightOffset;
					screenY =
						storm.flakeBottom ||
						document.documentElement.clientHeight ||
						document.body.clientHeight ||
						document.body.scrollHeight;
				}
				docHeight = document.body.offsetHeight;
				screenX2 = parseInt(screenX / 2, 10);
			};

			this.resizeHandlerAlt = function() {
				screenX =
					storm.targetElement.offsetWidth - storm.flakeRightOffset;
				screenY = storm.flakeBottom || storm.targetElement.offsetHeight;
				screenX2 = parseInt(screenX / 2, 10);
				docHeight = document.body.offsetHeight;
			};

			this.freeze = function() {
				// pause animation
				if (!storm.disabled) {
					storm.disabled = 1;
				} else {
					return false;
				}
				storm.timer = null;
			};

			this.resume = function() {
				if (storm.disabled) {
					storm.disabled = 0;
				} else {
					return false;
				}
				storm.timerInit();
			};

			this.toggleSnow = function() {
				if (!storm.flakes.length) {
					// first run
					storm.start();
				} else {
					storm.active = !storm.active;
					if (storm.active) {
						storm.show();
						storm.resume();
					} else {
						storm.stop();
						storm.freeze();
					}
				}
			};

			this.stop = function() {
				let i;
				this.freeze();
				for (i = 0; i < this.flakes.length; i ++) {
					this.flakes[ i ].o.style.display = 'none';
				}
				storm.events.remove(window, 'scroll', storm.scrollHandler);
				storm.events.remove(window, 'resize', storm.resizeHandler);
				if (storm.freezeOnBlur) {
					if (isIE) {
						storm.events.remove(document, 'focusout', storm.freeze);
						storm.events.remove(document, 'focusin', storm.resume);
					} else {
						storm.events.remove(window, 'blur', storm.freeze);
						storm.events.remove(window, 'focus', storm.resume);
					}
				}
			};

			this.show = function() {
				let i;
				for (i = 0; i < this.flakes.length; i ++) {
					this.flakes[ i ].o.style.display = 'block';
				}
			};

			this.SnowFlake = function(type, x, y) {
				const s = this;
				this.type = type;
				this.x = x || parseInt(rnd(screenX - 20), 10);
				this.y = !isNaN(y) ? y : -rnd(screenY) - 12;
				this.vX = null;
				this.vY = null;
				this.vAmpTypes = [1, 1.2, 1.4, 1.6, 1.8]; // "amplification" for vX/vY (based on flake size/type)
				this.vAmp = this.vAmpTypes[ this.type ] || 1;
				this.melting = false;
				this.meltFrameCount = storm.meltFrameCount;
				this.meltFrames = storm.meltFrames;
				this.meltFrame = 0;
				this.twinkleFrame = 0;
				this.active = 1;
				this.fontSize = 10 + (this.type / 5) * 10;
				this.o = document.createElement('div');
				this.o.innerHTML = storm.snowCharacter;
				this.o.classList.add('snowy');

				if (storm.className) {
					this.o.setAttribute('class', storm.className);
				}
				this.o.style.color = storm.snowColor;
				this.o.style.position = fixedForEverything
					? 'fixed'
					: 'absolute';
				if (storm.useGPU && features.transform.prop) {
					// GPU-accelerated snow.
					this.o.style[ features.transform.prop ] =
						'translate3d(0px, 0px, 0px)';
				}
				this.o.style.width = storm.flakeWidth + 'px';
				this.o.style.height = storm.flakeHeight + 'px';
				this.o.style.fontFamily = 'arial,verdana';
				this.o.style.cursor = 'default';
				this.o.style.overflow = 'hidden';
				this.o.style.fontWeight = 'normal';
				this.o.style.zIndex = storm.zIndex;
				docFrag.appendChild(this.o);

				this.refresh = function() {
					if (isNaN(s.x) || isNaN(s.y)) {
						// safety check
						return false;
					}
					storm.setXY(s.o, s.x, s.y);
				};

				this.stick = function() {
					if (
						noFixed ||
						(storm.targetElement !== document.documentElement &&
							storm.targetElement !== document.body)
					) {
						s.o.style.top =
							screenY + scrollY - storm.flakeHeight + 'px';
					} else if (storm.flakeBottom) {
						s.o.style.top = storm.flakeBottom + 'px';
					} else {
						s.o.style.display = 'none';
						s.o.style.bottom = '0%';
						s.o.style.position = 'fixed';
						s.o.style.display = 'block';
					}
				};

				this.vCheck = function() {
					if (s.vX >= 0 && s.vX < 0.2) {
						s.vX = 0.2;
					} else if (s.vX < 0 && s.vX > -0.2) {
						s.vX = -0.2;
					}
					if (s.vY >= 0 && s.vY < 0.2) {
						s.vY = 0.2;
					}
				};

				this.move = function() {
					let vX = s.vX * windOffset,
						yDiff;
					s.x += vX;
					s.y += s.vY * s.vAmp;
					if (s.x >= screenX || screenX - s.x < storm.flakeWidth) {
						// X-axis scroll check
						s.x = 0;
					} else if (
						vX < 0 &&
						s.x - storm.flakeLeftOffset < -storm.flakeWidth
					) {
						s.x = screenX - storm.flakeWidth - 1; // flakeWidth;
					}
					s.refresh();
					yDiff = screenY + scrollY - s.y + storm.flakeHeight;
					if (yDiff < storm.flakeHeight) {
						s.active = 0;
						if (storm.snowStick) {
							s.stick();
						} else {
							s.recycle();
						}
					} else {
						if (
							storm.useMeltEffect &&
							s.active &&
							s.type < 3 &&
							!s.melting &&
							Math.random() > 0.998
						) {
							// ~1/1000 chance of melting mid-air, with each frame
							s.melting = true;
							s.melt();
							// only incrementally melt one frame
							// s.melting = false;
						}
						if (storm.useTwinkleEffect) {
							if (s.twinkleFrame < 0) {
								if (Math.random() > 0.97) {
									s.twinkleFrame = parseInt(
										Math.random() * 8,
										10
									);
								}
							} else {
								s.twinkleFrame--;
								if (!opacitySupported) {
									s.o.style.visibility =
										s.twinkleFrame &&
										s.twinkleFrame % 2 === 0
											? 'hidden'
											: 'visible';
								} else {
									s.o.style.opacity =
										s.twinkleFrame &&
										s.twinkleFrame % 2 === 0
											? 0
											: 1;
								}
							}
						}
					}
				};

				this.animate = function() {
					// main animation loop
					// move, check status, die etc.
					s.move();
				};

				this.setVelocities = function() {
					s.vX = vRndX + rnd(storm.vMaxX * 0.12, 0.1);
					s.vY = vRndY + rnd(storm.vMaxY * 0.12, 0.1);
				};

				this.setOpacity = function(o, opacity) {
					if (!opacitySupported) {
						return false;
					}
					o.style.opacity = opacity;
				};

				this.melt = function() {
					if (!storm.useMeltEffect || !s.melting) {
						s.recycle();
					} else if (s.meltFrame < s.meltFrameCount) {
						s.setOpacity(s.o, s.meltFrames[ s.meltFrame ]);
						s.o.style.fontSize =
							s.fontSize -
							s.fontSize * (s.meltFrame / s.meltFrameCount) +
							'px';
						s.o.style.lineHeight =
							storm.flakeHeight +
							2 +
							storm.flakeHeight *
								0.75 *
								(s.meltFrame / s.meltFrameCount) +
							'px';
						s.meltFrame ++;
					} else {
						s.recycle();
					}
				};

				this.recycle = function() {
					s.o.style.display = 'none';
					s.o.style.position = fixedForEverything
						? 'fixed'
						: 'absolute';
					s.o.style.bottom = 'auto';
					s.setVelocities();
					s.vCheck();
					s.meltFrame = 0;
					s.melting = false;
					s.setOpacity(s.o, 1);
					s.o.style.padding = '0px';
					s.o.style.margin = '0px';
					s.o.style.fontSize = s.fontSize + 'px';
					s.o.style.lineHeight = storm.flakeHeight + 2 + 'px';
					s.o.style.textAlign = 'center';
					s.o.style.verticalAlign = 'baseline';
					s.x = parseInt(rnd(screenX - storm.flakeWidth - 20), 10);
					s.y = parseInt(rnd(screenY) * -1, 10) - storm.flakeHeight;
					s.refresh();
					s.o.style.display = 'block';
					s.active = 1;
				};

				this.recycle(); // set up x/y coords etc.
				this.refresh();
			};

			this.snow = function() {
				let active = 0,
					flake = null,
					i,
					j;
				for (i = 0, j = storm.flakes.length; i < j; i ++) {
					if (storm.flakes[ i ].active === 1) {
						storm.flakes[ i ].move();
						active ++;
					}
					if (storm.flakes[ i ].melting) {
						storm.flakes[ i ].melt();
					}
				}
				if (active < storm.flakesMaxActive) {
					flake =
						storm.flakes[ parseInt(rnd(storm.flakes.length), 10) ];
					if (flake.active === 0) {
						flake.melting = true;
					}
				}
				if (storm.timer) {
					features.getAnimationFrame(storm.snow);
				}
			};

			this.mouseMove = function(e) {
				if (!storm.followMouse) {
					return true;
				}
				let x = parseInt(e.clientX, 10);
				if (x < screenX2) {
					windOffset =
						-windMultiplier + (x / screenX2) * windMultiplier;
				} else {
					x -= screenX2;
					windOffset = (x / screenX2) * windMultiplier;
				}
			};

			this.createSnow = function(limit, allowInactive) {
				let i;
				for (i = 0; i < limit; i ++) {
					storm.flakes[ storm.flakes.length ] = new storm.SnowFlake(
						parseInt(rnd(flakeTypes), 10)
					);
					if (allowInactive || i > storm.flakesMaxActive) {
						storm.flakes[ storm.flakes.length - 1 ].active = -1;
					}
				}
				storm.targetElement.appendChild(docFrag);
			};

			this.timerInit = function() {
				storm.timer = true;
				storm.snow();
			};

			this.init = function() {
				let i;
				for (i = 0; i < storm.meltFrameCount; i ++) {
					storm.meltFrames.push(1 - i / storm.meltFrameCount);
				}
				storm.randomizeWind();
				storm.createSnow(storm.flakesMax); // create initial batch
				storm.events.add(window, 'resize', storm.resizeHandler);
				storm.events.add(window, 'scroll', storm.scrollHandler);
				if (storm.freezeOnBlur) {
					if (isIE) {
						storm.events.add(document, 'focusout', storm.freeze);
						storm.events.add(document, 'focusin', storm.resume);
					} else {
						storm.events.add(window, 'blur', storm.freeze);
						storm.events.add(window, 'focus', storm.resume);
					}
				}
				storm.resizeHandler();
				storm.scrollHandler();
				if (storm.followMouse) {
					storm.events.add(
						isIE ? document : window,
						'mousemove',
						storm.mouseMove
					);
				}
				storm.animationInterval = Math.max(20, storm.animationInterval);
				storm.timerInit();
			};

			this.start = function(bFromOnLoad) {
				if (!didInit) {
					didInit = true;
				} else if (bFromOnLoad) {
					// already loaded and running
					return true;
				}
				if (typeof storm.targetElement === 'string') {
					const targetID = storm.targetElement;
					storm.targetElement = document.getElementById(targetID);
					if (!storm.targetElement) {
						throw new Error(
							'Snowstorm: Unable to get targetElement "' +
								targetID +
								'"'
						);
					}
				}
				if (!storm.targetElement) {
					storm.targetElement =
						document.body || document.documentElement;
				}
				if (
					storm.targetElement !== document.documentElement &&
					storm.targetElement !== document.body
				) {
					// re-map handler to get element instead of screen dimensions
					storm.resizeHandler = storm.resizeHandlerAlt;
					//and force-enable pixel positioning
					storm.usePixelPosition = true;
				}
				storm.resizeHandler(); // get bounding box elements
				storm.usePositionFixed =
					storm.usePositionFixed && !noFixed && !storm.flakeBottom; // whether or not position:fixed is to be used
				if (window.getComputedStyle) {
					// attempt to determine if body or user-specified snow parent element is relatlively-positioned.
					try {
						targetElementIsRelative =
							window
								.getComputedStyle(storm.targetElement, null)
								.getPropertyValue('position') === 'relative';
					} catch (e) {
						// oh well
						targetElementIsRelative = false;
					}
				}
				fixedForEverything = storm.usePositionFixed;
				if (screenX && screenY && !storm.disabled) {
					storm.init();
					storm.active = true;
				}
			};

			function doDelayedStart() {
				window.setTimeout(function() {
					storm.start(true);
				}, 20);
				// event cleanup
				storm.events.remove(
					isIE ? document : window,
					'mousemove',
					doDelayedStart
				);
			}

			function doStart() {
				if (!storm.excludeMobile || !isMobile) {
					doDelayedStart();
				}
				// event cleanup
				storm.events.remove(window, 'load', doStart);
			}

			// hooks for starting the snow
			if (storm.autoStart) {
				storm.events.add(window, 'load', doStart, false);
			}

			return this;
		}(window, document));

		snowStorm();
	}
})(document, window, history);
